import type { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import type { NextPageContext } from 'next';
import { apolloClient } from '@/api/apolloClient';
import { GET_PACKAGES_LIST } from '@/api/queries/business.queries';
import type { PackagesListData } from '@/api/types/business.types';

export async function getServerPackagesList(
  client: ApolloClient<NormalizedCacheObject>,
  context: NextPageContext
): Promise<PackagesListData | null> {
  const packagesResponse = await apolloClient<PackagesListData>(
    client,
    {
      query: GET_PACKAGES_LIST,
      fetchPolicy: 'no-cache',
    },
    context
  );

  return packagesResponse?.data ?? null;
}
